import { BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';

import { flags } from '@treams/treams-icons';
import { ComponentProps } from 'react';

export type FlagProps = ComponentProps<typeof Flag>;

const Container = styled(Flex)`
	background: ${(props) => props.theme.colors.lightBlueLight};
	border-radius: 2px;
	padding-top: 67%;
	flex-grow: 1;
	flex-shrink: 1;
	position: relative;
	overflow: hidden;

	svg {
		position: absolute;
		top: 0;
		flex-grow: 1;
		flex-shrink: 1;
		width: 100%;
		height: 100%;
	}
`;

export function Flag(props: { languageID: keyof typeof flags } & BoxProps) {
	const { languageID, ...rest } = props;
	const Component = flags[languageID];

	return <Container {...rest}>{Component && <Component />}</Container>;
}
